module.exports = __webpack_public_path__ + "static/media/Digital Health Card.ccc22112.svg";